module.exports = __webpack_public_path__ + "static/media/10.e36b66aa.jpg";